import React from 'react';
import { gql } from '@apollo/client';
import { Show, TabbedShowLayout, Tab, TabbedShowLayoutTabs, NumberField } from 'react-admin';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';
import PercentField from 'components/PercentField';

const JobProfileShow = () => (
  <Show>
    <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" />}>
      <Tab label="Info">
        <IdField />
        <LinkField label="Job ID" source="job_id" />
        <NumberField label="Agency ID" source="agency_id" />
        <PercentField label="Agency VMS Fee percent" source="agency_vms_fee_percent" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

JobProfileShow.query = gql`
  query GET_ONE($id: Int!) {
    jobProfile(id: $id) {
      agency_id
      agency_vms_fee_percent
      id
      job_id
    }
  }
`;

export default JobProfileShow;
